import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { FormTextAreaAutosize } from "@circle-react-shared/uikit/Form/FormTextAreaAutosize";
import { Form } from "@circle-react-uikit/Form";
import { LinkInput } from "@circle-react-uikit/Form/LinkInput";
import { ImageInput } from "@circle-react-uikit/ImageInput";
import { Typography } from "@circle-react-uikit/Typography";
import { ImageUploadBlock } from "./ImageUploadBlock";

const translationRoot = "courses.directory.options_modal.banner";
interface BannerTabProps {
  isLoggedIn: boolean;
}
export const BannerTab = ({ isLoggedIn }: BannerTabProps) => {
  const tabType = isLoggedIn ? "logged_in" : "logged_out";
  const { watch } = useFormContext();
  const isBannerEnabled = watch(`${tabType}_banner_enabled`);
  return (
    <div className="w-full">
      <Form.Item
        name={`${tabType}_banner_enabled`}
        translationRoot={translationRoot}
        hideDescription
        hideBorder
        className="!mt-3 !flex"
        labelClassName="text-xl mb-0"
      >
        <Form.ToggleSwitch
          name={`${tabType}_banner_enabled`}
          variant="large"
          wrapperClass="max-w-none"
        />
      </Form.Item>
      <div
        className={classNames("w-full", {
          "pointer-events-none cursor-not-allowed opacity-20": !isBannerEnabled,
        })}
      >
        <Form.Item
          name={`${tabType}_banner_image[signed_id]`}
          hideBorder
          hideDescription
          labelClassName="text-xl text-darkest pb-1"
          label={t([translationRoot, "banner_image"])}
        >
          <ImageInput
            name={`${tabType}_banner_image[signed_id]`}
            customAspectRatioHelpText={t([
              translationRoot,
              "upload.dimensions_help",
            ])}
            aspectRatio={1279 / 680}
            hideUnsplash
            hideEmbedUrl
            renderer={ImageUploadBlock}
          />
        </Form.Item>
        <div className="border-primary mt-6 rounded-md border p-6">
          <Typography.TitleSm weight="semibold">
            {t([translationRoot, "text"])}
          </Typography.TitleSm>
          <Form.Item
            name={`${tabType}_banner_title`}
            translationRoot={translationRoot}
            hideDescription
            errorClassName="form-group__error !mb-0"
            hideBorder
            rules={{
              maxLength: {
                value: 255,
                message: t([translationRoot, "max_length_255"]),
              },
            }}
          >
            <Form.Input name={`${tabType}_banner_title`} autoComplete="off" />
          </Form.Item>
          <Form.Item
            name={`${tabType}_banner_text`}
            translationRoot={translationRoot}
            hideDescription
            hideBorder
          >
            <FormTextAreaAutosize
              name={`${tabType}_banner_text`}
              className="form-control text-default flex w-full rounded-lg ring-current focus-within:ring-1"
            />
          </Form.Item>
        </div>
        <div className="border-primary mt-6 rounded-md border p-6">
          <Typography.TitleSm weight="semibold">
            {t([translationRoot, "button"])}
          </Typography.TitleSm>
          <Form.Item
            name={`${tabType}_banner_button_label`}
            translationRoot={translationRoot}
            hideDescription
            errorClassName="form-group__error !mb-0"
            hideBorder
            rules={{
              maxLength: {
                value: 255,
                message: t([translationRoot, "max_length_255"]),
              },
            }}
          >
            <Form.Input
              name={`${tabType}_banner_button_label`}
              autoComplete="off"
            />
          </Form.Item>
          <Form.Item
            name={`${tabType}_banner_button_link`}
            translationRoot={translationRoot}
            hideDescription
            hideBorder
          >
            <LinkInput
              name={`${tabType}_banner_button_link`}
              autoComplete="off"
            />
          </Form.Item>
        </div>
      </div>
    </div>
  );
};
